import { Autocomplete } from 'mui-rff';
import { useSelector } from 'react-redux';
import { selectUsuarios } from '../../features/usuario/usuarioSlice';

export default function QCXSelectUsuarioAutoComplete({
  name,
  disabled,
  label = 'Selecione o usuário',
  concatOptions = [],
}) {
  const usuarios = useSelector(selectUsuarios);

  const usuariosWithDefaultValue = concatOptions.concat(usuarios);

  return (
    <Autocomplete
      name={name}
      label={label}
      options={usuariosWithDefaultValue}
      textFieldProps={{
        variant: 'outlined',
        size: 'small',
        InputLabelProps: {
          shrink: true,
          style: {
            textTransform: 'uppercase',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        },
      }}
      getOptionLabel={(option) => option?.nome ?? '-'}
      disabled={disabled}
    />
  );
}
